import "../../style.scss";
import { useModal } from "context/ModalContext/Modal.context";
import { format } from "date-fns/format";
import { ptBR } from "date-fns/locale/pt-BR";
import { GrDownload } from "react-icons/gr";
import {
  Documento,
  Realization,
} from "types/realization";
import { FaCheck } from "react-icons/fa6";


interface Options {
  data: Realization;
  confirmedPlayerList?: any;
  category: string;
  owner: string;
  owner_name: string;
  inscricao_mat: string;
  inscricao_name: string;
  documento: Documento[];
}

const ModalParticipantsEvaluation = ({ data, confirmedPlayerList, category, owner, owner_name, inscricao_mat, inscricao_name, documento  }: Options) => {
  const { closeModal } = useModal();

  return (
    <div className="detail">
      {category &&
      <div className="tag">
          <span>{String(category)}</span>
      </div>
      }
      <h2 className="mb-2 mt-3 text-lg font-medium font-bb text-black-bb">
        <strong>Realização: </strong>
         {data.title}
      </h2>
      <div className="p-4 bg-gray-bb-3">
          <>

             <h6 className="text-sm text-black-bb">
              <strong>Cadastrado por:</strong>
            </h6>
            <p>
              {owner_name} ({owner}), em{" "}
              {format(data.created, "dd 'de' MMMM 'de' yyyy", {
                locale: ptBR,
              })}
            </p>

             <>
                <p className="mt-2 mb-2 text-sm font-bold text-black-bb">
                  <strong>Inscrito por:</strong>
                </p>
                <p>
                  {inscricao_name} (
                  {inscricao_mat})
                </p>
              </>
            <h6 className="mt-2 text-sm text-black-bb">
              <strong>Detalhes da realização</strong>
            </h6>

            <p dangerouslySetInnerHTML={{ __html: data.description }} />

            <h6 className="mt-2 text-sm text-black-bb">
              <strong>Resultado da realização</strong>
            </h6>

            <p dangerouslySetInnerHTML={{ __html: data.result }} />

            {data.team_data && data.team_data.length > 0 && (
              <>
                <h6 className="mt-2 text-sm text-black-bb">
                  <strong>
                    {`Participantes da realização (${
                      confirmedPlayerList?.confirmados.length || 0
                    } de
                    ${data.team_data.length | 0} participantes
                    confirmados)`}
                  </strong>
                </h6>
                {data.team_data.map((item) => (
                  <p
                    className={`${
                      confirmedPlayerList?.confirmados.includes(item.chave)
                        ? "text-green-bb"
                        : "pl-5"
                    }`}
                  >
                    {confirmedPlayerList?.confirmados.includes(item.chave) && (
                      <FaCheck className="inline mr-1" />
                    )}
                    {item.nome_guerra} ({item.chave}) - {item.diretoria && item.diretoria} - {item.prefixo && item.prefixo}
                  </p>
                ))}
              </>
            )}
          </>
             {!!documento && documento.length > 0 ? (
              <>
                <p className="mt-2 mb-2 text-sm font-bold text-black-bb">
                  <strong>Documentação complementar da realização</strong>
                </p>
                {documento.map((item) => (
                  <>
                    {!!item && item !== null && (
                      <>
                        {item.type === "video" ? (
                          <div className="relative mt-6">
                            <div className="mt-6">
                              <a
                                href={item.file}
                                className="mt-4 px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-700"
                                target="_blank"
                                rel="noreferrer"
                              >
                                Ver vídeo
                              </a>
                            </div>
                          </div>
                        ) : (
                          <div className="mt-6">
                            <button
                              className="rounded-[4px] py-[14px] px-5 bg-gray-bb-2 text-white-bb-1 uppercase flex items-center gap-2 font-bold"
                              onClick={() => {
                                window.open(item.file, "_blank");
                              }}
                            >
                              <GrDownload size={22} />
                              Download
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </>
                ))}
              </>
            ) : (
              <></>
            )}
      </div>

      <div className="flex items-center justify-center">
        <button
          className="px-4 py-3 font-bold uppercase text-blue-bb"
          onClick={closeModal}
        >
          Fechar
        </button>
      </div>
    </div>
  );
};

export default ModalParticipantsEvaluation;
